export { default as shedQueries } from './basic'